module.exports = __webpack_public_path__ + "img/badge_gray_spe-beta.5c351e39.svg";